export class HotSpot extends pc.ScriptType {
    
    initialize() {
        this.ray = new pc.Ray();
        this.cameraEntity = pc.app.root.findByName("Camera");
        this.mat_up = this.entity.children[0].model.meshInstances[0].material.clone();
        //this.mat_dn = pc.app.assets.find('HS_' + this.entity.name.split('_')[1] + '_dn', "material").resource;
        this.state = "up";
        this.mode = "web";
        this.offset = 20;

		//this.entity.addComponent("model", { type: "box" });
		this.hitArea = new pc.BoundingBox(this.entity.getPosition());

        //this.hitArea.halfExtents.z = this.hitArea.halfExtents.x; //add 'depth' to the hotspot so it is always clickable as it rotates
    
        this.app.mouse.on(pc.EVENT_MOUSEDOWN, this.onMouseDown, this);
    
        if (this.app.touch) {
            this.app.touch.on(pc.EVENT_TOUCHSTART, this.onTouchStart, this);
        }
    };
    
    onMouseDown = function(event) {
        if (event.button == pc.MOUSEBUTTON_LEFT) {
            this.doRayCast(event);
        }
    };
    
    onTouchStart = function (event) {
        if (event.touches.length == 1) {
            this.doRayCast(event.touches[0]);
            event.event.preventDefault();
        }
    };
    
    doRayCast = function (screenPosition) {
        if(this.entity.parent.enabled == true && this.entity.enabled == true){
            this.cameraEntity.camera.screenToWorld(screenPosition.x, screenPosition.y, this.cameraEntity.camera.farClip, this.ray.direction);
            this.ray.origin.copy(this.cameraEntity.getPosition());
            this.ray.direction.sub(this.ray.origin).normalize();
        
            if (this.hitArea.intersectsRay(this.ray)) {;
                //if(this.state == 'up') this.state = 'down';
                //else this.state = 'up';
                //this.showState(this.state);
                this.app.fire('hotspot', this.entity.name); //dispatch playcanvas custom event to communicate with React
            }
        }      
    };

    showState = function(state){
        this.entity.enabled = true;      
        if(state === 'down') {            
            this.entity.enabled = false;        }
        if(state === 'hidden') this.entity.enabled = false;
        this.state = state;
        //this.entity.children[0].model.meshInstances[0].material = this.mat_up; //changed from swapping textures to hiding completely
        //this.entity.children[0].model.meshInstances[0].material.update(); //changed from swapping textures to hiding completely
        //this.entity.children[0].model.meshInstances[0].material = this.mat_dn; //changed from swapping textures to hiding completely
    }
    
    update(dt) {        
        var cameraRot = this.cameraEntity.getLocalRotation();       
        var currRot = cameraRot.clone();
        this.entity.setLocalRotation(currRot);
        if(this.cameraEntity?.script?.OrbitCamera){
            let scale = (this.cameraEntity.getPosition().distance(this.entity.getPosition()))  / this.offset;
            this.entity.setLocalScale(scale, scale, scale);
			this.hitArea.halfExtents.x = 0.5 * scale/2;
			this.hitArea.halfExtents.y = 0.5 * scale/6;
			this.hitArea.halfExtents.z = 0.5 * scale;			
        }        
    };
    
}